import { create } from "zustand";
import { cleanUrl } from "./utils";

interface KnowledgeStoreState {
  urls: string[];
  imageUrl?: string;
  pendingUrl?: string;
  push: (href: string) => void;
  pop: () => void;
  reset: () => void;
}

export const useKnowledgeStore = create<KnowledgeStoreState>()((set) => ({
  urls: ["site-hierarchy.md"],
  push: (href) =>
    set((state) => ({
      open: true,
      urls:
        state.urls.at(-1) === cleanUrl(href)
          ? state.urls
          : [...state.urls, cleanUrl(href)],
    })),
  pop: () =>
    set((state) => ({
      urls: state.urls.length <= 1 ? state.urls : state.urls.slice(0, -1),
    })),
  reset: () => set({ urls: ["site-hierarchy.md"] }),
}));
